import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#595959",
  "fill-rule": "evenodd",
  d: "M.833 1.333a.5.5 0 0 1 .5-.5h1.16c.793 0 1.453.534 1.662 1.247h8.331a2.349 2.349 0 0 1 2.372 2.543l-.36 5v.002c-.093 1.211-1.148 2.202-2.371 2.202h-7.1a2.364 2.364 0 0 1-2.359-2.562l.554-6.64a.734.734 0 0 0-.729-.792h-1.16a.5.5 0 0 1-.5-.5ZM4.187 3.08l-.522 6.268v.001a1.364 1.364 0 0 0 1.361 1.478h7.1c.696 0 1.321-.583 1.375-1.278l.36-4.998c.059-.816-.55-1.471-1.375-1.471H4.188ZM10.833 13.5a.333.333 0 1 0 0 .667.333.333 0 0 0 0-.667Zm-1.333.333a1.333 1.333 0 1 1 2.666 0 1.333 1.333 0 0 1-2.666 0ZM5.5 13.5a.333.333 0 1 0 0 .667.333.333 0 0 0 0-.667Zm-1.333.333a1.333 1.333 0 1 1 2.666 0 1.333 1.333 0 0 1-2.667 0Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#595959",
  "fill-rule": "evenodd",
  d: "M5.5 5.333a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }